/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.before-after-slider-outer' ).slick( {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: $( '.before-after-nav-wrapper' ),
        prevArrow: '<button type="button" class="prev-arrow"><svg class="mr-3 text-2xl icon icon-right-arrow reverse-arrow svg-align"><use xlink:href="#icon-right-arrow"></use></svg>Previous case</button>',
        nextArrow: '<button type="button" class="next-arrow">Next case<svg class="ml-3 text-2xl icon icon-right-arrow svg-align"><use xlink:href="#icon-right-arrow"></use></svg></button>',
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
